var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3827 4.74672V3.59137H14.121L15.6084 1.77492L14.7017 1.0325L12.6064 3.59137H9.27385C8.91361 1.82953 7.35158 0.5 5.48486 0.5C3.35248 0.5 1.61768 2.2348 1.61768 4.36719C1.61768 6.49957 3.35248 8.23438 5.48486 8.23438C6.14818 8.23438 6.77299 8.06641 7.31912 7.77094L11.0317 12.3232V19.3281H8.70103V20.5H14.5344V19.3281H12.2036V12.3232L18.3827 4.74672ZM6.37838 4.76324H9.96627C9.71189 5.15043 9.56576 5.58719 9.54932 6.02055C9.52725 6.60145 9.74666 7.12973 10.1513 7.46992C10.4548 7.725 10.8444 7.85934 11.2601 7.85934C11.3988 7.85934 11.5404 7.84438 11.6826 7.81395C12.2055 7.70211 12.6996 7.39527 13.074 6.94992C13.4484 6.50457 13.6657 5.96508 13.6861 5.43074C13.695 5.19664 13.664 4.97141 13.5981 4.76324H16.857L11.6177 11.1875L6.37838 4.76324ZM12.5151 5.38621C12.5047 5.65742 12.3815 5.9525 12.177 6.19582C11.9725 6.4391 11.7029 6.61121 11.4375 6.66797C11.3128 6.69465 11.0778 6.71773 10.9054 6.57285C10.6075 6.32238 10.679 5.70676 11.0584 5.25543C11.3199 4.9443 11.6835 4.76395 11.9819 4.76395C12.1162 4.76395 12.2374 4.80059 12.3299 4.87836C12.5023 5.02328 12.5199 5.25875 12.5151 5.38621ZM5.48486 7.0625C3.99865 7.0625 2.78955 5.8534 2.78955 4.36719C2.78955 2.88098 3.99865 1.67188 5.48486 1.67188C6.70143 1.67188 7.73182 2.48223 8.06584 3.59137H4.85271V4.74672L6.55881 6.83867C6.22955 6.98231 5.86646 7.0625 5.48486 7.0625Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.b8c23b14537a4b75f8ab860c9467cefc.svg";
export { ForwardRef as ReactComponent };